/** Marks a row as sample data (see lib/samples.js) — never shown on a real one. */
export default function SampleTag({ show = true }) {
  if (!show) return null
  return (
    <span className="sample-tag" title="Sample data — not a real client or record. Actions on it do nothing.">
      Sample
    </span>
  )
}
